import { ImageType, generateImageUrl } from '@audacy-clients/core/utils/image';

// Reference: https://developer.fastly.com/reference/io/
export const formatSrc = (src: string, width: number): string => {
  const srcStandard = generateImageUrl(src, width || 100, ImageType.Full);
  const srcRetina = generateImageUrl(src, 2 * width || 200, ImageType.Full);
  return `${srcStandard} 1x, ${srcRetina} 2x`;
};
